import { useState, useRef, useEffect } from 'react';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-background-50/80 backdrop-blur-md">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a href="/" className="flex items-center gap-2 no-underline">
            <span className="text-xl md:text-2xl font-heading font-bold text-foreground-950 tracking-tight">
              Kakobuy <span className="text-primary-500">Finds</span>
            </span>
          </a>

          <div className="hidden md:flex items-center gap-6">
            <a href="/" className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap">
              Strona główna
            </a>

            <div className="relative group">
              <span className="text-sm font-medium text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1">
                Poradniki
                <i className="ri-arrow-down-s-line text-xs"></i>
              </span>
              <div className="absolute top-full left-0 mt-2 w-72 bg-background-50 rounded-lg border border-background-200/70 py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 shadow-sm">
                <a href="/artykul/kakobuy-sheet-kompletny-przewodnik" className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Kakobuy Sheet – Kompletny Przewodnik
                </a>
                <a href="/artykul/cssbuy-spreadsheet-vs-kakobuy" className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  CSSBuy vs Kakobuy – Porównanie
                </a>
                <a href="/artykul/superbuy-spreadsheet-przewodnik" className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Superbuy Spreadsheet – Przewodnik
                </a>
                <a href="/artykul/oopbuy-spreadsheet-przewodnik" className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  Oopbuy Spreadsheet – Przewodnik
                </a>
              </div>
            </div>

            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 border border-background-200/70 text-sm font-medium text-foreground-800 hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>Kategorie</span>
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {dropdownOpen && (
                <div className="absolute top-full mt-2 right-0 w-64 bg-background-50 rounded-lg border border-background-200/70 py-2 max-h-80 overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap"
                      onClick={() => setDropdownOpen(false)}
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Open Spreadsheet
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden flex items-center justify-center w-10 h-10 text-foreground-800 cursor-pointer"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden pb-6 border-t border-background-200/70 pt-4 max-h-[70vh] overflow-y-auto">
            <a
              href="/"
              className="flex items-center gap-3 py-3 text-sm font-semibold text-foreground-800 hover:text-foreground-950 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-home-line text-lg w-6 h-6 flex items-center justify-center text-primary-500"></i>
              Strona główna
            </a>

            <div className="mt-3 mb-1">
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider px-1 mb-2">Poradniki SEO</p>
              <a
                href="/artykul/kakobuy-sheet-kompletny-przewodnik"
                className="flex items-center gap-3 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                <i className="ri-article-line text-lg w-6 h-6 flex items-center justify-center text-primary-500"></i>
                Kakobuy Sheet – Kompletny Przewodnik
              </a>
              <a
                href="/artykul/cssbuy-spreadsheet-vs-kakobuy"
                className="flex items-center gap-3 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                <i className="ri-scales-line text-lg w-6 h-6 flex items-center justify-center text-accent-500"></i>
                CSSBuy vs Kakobuy – Porównanie
              </a>
              <a
                href="/artykul/superbuy-spreadsheet-przewodnik"
                className="flex items-center gap-3 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                <i className="ri-guide-line text-lg w-6 h-6 flex items-center justify-center text-secondary-500"></i>
                Superbuy Spreadsheet – Przewodnik
              </a>
              <a
                href="/artykul/oopbuy-spreadsheet-przewodnik"
                className="flex items-center gap-3 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                <i className="ri-book-open-line text-lg w-6 h-6 flex items-center justify-center text-accent-500"></i>
                Oopbuy Spreadsheet – Przewodnik
              </a>
            </div>

            <div className="mt-4 mb-1">
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider px-1 mb-2">
                Kategorie produktów
                <span className="text-primary-500 ml-1">({categories.length})</span>
              </p>
              <div className="grid grid-cols-2 gap-1">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-2 px-2 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></span>
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div className="mt-5 pt-4 border-t border-background-200/70">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Open Spreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}